import * as searchActions from './actions';
import searchEpics from './epics';
import reducer from './reducers';
import * as searchSelectors from './selectors';
import * as searchTypes from './types';

export { searchActions, searchEpics, searchSelectors, searchTypes };

export default reducer;
